/*
  SimplySecured MOQ guard
  File: assets/ss-moq.js

  MOQ is treated as a required ordering multiple.
  Example: MOQ 5 means valid quantities are 5, 10, 15, 20, etc.

  Theme-side guard only:
  - Sets product quantity min/step.
  - Suppresses accelerated checkout buttons on MOQ products.
  - Blocks normal checkout attempts when invalid MOQ quantities exist.
  - Rounds invalid cart quantities up to the next valid multiple.
*/

(function () {
  'use strict';

  var RULES_BY_HANDLE = {
    'fv07vba1': 4,
    'fv07vbb1': 4,
    'mounting-plate-for-2-and-4-models-with-square-hole': 5,
    'lotus-led-rip-s-358': 5,
    'lotus-led-rip-s-258': 5,
    'lotus-led-rip-m-23': 5,
    'lotus-led-rip414': 5,
    'lotus-led-rip334': 5,
    'lotus-led-rip314': 5,
    'lotus-led-rip234': 5,
    'lotus-led-mp6-114fr': 5,
    'lotus-led-mp-5-10': 5,
    'lotus-led-mp4-114fr': 5,
    'lotus-led-mp338': 5,
    'lotus-led-mp214': 5,

    'surface-mount-lh-1708-sw-1p': 10,
    'surface-mount-lh-1415-sw-1p': 10,
    'recessed-lh-2515-sw-1p': 10,
    'recessed-lh-2408-sw-1p': 10,
    'lotolite-4-slim-round-panel-led-1000-lm-9w-sc-dl09-d04h-a1-61re': 32,
    'led-fixture-lh-5713-sw-1p': 10,
    'led-fixture-lh-1818-sw-1p': 10,

    'fvfl1316ve1': 4,
    'fvfl0815ve1': 4,
    'fvfl0616ve1': 4,

    'apoejk2-wh': 40,
    'poejkds2-wh': 100,
    'poejkds4-wh': 100,
    'poejkds2-bk': 100,
    'poejkds4-bk': 100,

    'grp6a-005-rw': 25,
    'grp6a-010-rw': 25,
    'grp6a-020-rw': 25,
    'grp6a-030-rw': 25,

    'poejc6a-cmp': 36,
    'poejc6-cmr': 36,
    'poejc6e-cmp': 36,

    'dms-001': 100,
    'poejk-touch10-wh': 10,

    '2-flat-rough-in-plates': 5,
    '2-1-2-flat-rough-in-plates': 5,
    '2-3-4-flat-rough-in-plates': 5,
    '3-1-2-flat-rough-in-plates': 5,
    '3-3-4-budget-flat-rough-in-plates': 5,
    '4-flat-rough-in-plates': 5,
    '4-budget-flat-rough-in-plates': 5,
    '4-budget-flanged-rough-in-plates': 5,
    '4-1-2-flat-rough-in-plates': 5,
    '5-flat-rough-in-plates': 5,
    '6-flat-rough-in-plates': 5,
    '6-budget-flat-rough-in-plates': 5,
    '6-1-2-flat-rough-in-plates': 5,
    '8-flat-rough-in-plates': 5,
    '3-flat-rough-in-plates-20-pack': 5,

    'lotolite-6-slim-round-panel-led-1400lm-12w-sc-dl12-d06h-a1-61re': 28,

    'panasonic-fvfl1320ve1': 4,
    'panasonic-fvfl1315nl1': 4,
    'panasonic-fvfl1310ve1': 4,
    'panasonic-fvfl0820ve1': 4,
    'panasonic-fvfl0815nl1': 4,
    'panasonic-fvfl0810ve1': 4,

    'vapour-barrier-14-x-8-x-4-inch': 100
  };

  var RULES_BY_SKU = {
    'FV07VBA1': 4,
    'FV07VBB1': 4,
    'MP-SQ-24': 5,
    'RIP-S-358': 5,
    'RIP-S-258': 5,
    'RIP-M-23': 5,
    'RIP414': 5,
    'RIP334': 5,
    'RIP314': 5,
    'RIP234': 5,
    'MP6-114FR': 5,
    'MP-5-10-LIN': 5,
    'MP4-114FR': 5,
    'MP338': 5,
    'MP214': 5,

    'LH-1708-SW-4FT-1P': 10,
    'LH-1708-SW-8FT-1P': 10,
    'LH-1415-SW-4FT-1P': 10,
    'LH-1415-SW-8FT-1P': 10,
    'LH-2515-SW-4FT-1P': 10,
    'LH-2515-SW-8FT-1P': 10,
    'LH-2408-SW-4FT-1P': 10,
    'LH-2408-SW-8FT-1P': 10,
    'SC-DL09-D04H-A1-61RE-WH': 32,
    'SC-DL09-D04H-A1-61RE-BK': 32,
    'LH-5713-SW-4FT-1P': 10,
    'LH-5713-SW-8FT-1P': 10,
    'LH-1818-SW-4FT-1P': 10,
    'LH-1818-SW-8FT-1P': 10,

    'FVFL1316VE1': 4,
    'FVFL0815VE1': 4,
    'FVFL0616VE1': 4,

    'APOEJK2-WH': 40,
    'POEJKDS2-WH': 100,
    'POEJKDS4-WH': 100,
    'POEJKDS2-BK': 100,
    'POEJKDS4-BK': 100,

    'GRP6A-005-RW': 25,
    'GRP6A-010-RW': 25,
    'GRP6A-020-RW': 25,
    'GRP6A-030-RW': 25,

    'POEJC6A-CMP': 36,
    'POEJC6-CMR': 36,
    'POEJC6E-CMP': 36,

    'DMS-001': 100,
    'POEJK-TOUCH10-WH': 10,

    'RIP2': 5,
    'RIP212': 5,
    'MP234': 5,
    'RIP312': 5,
    'MP334': 5,
    'RIP4': 5,
    'MP4-2': 5,
    'MP4': 5,
    'RIP412': 5,
    'RIP5': 5,
    'RIP6': 5,
    'MP6-2': 5,
    'RIP612': 5,
    'RIP8': 5,
    'RIP3': 5,

    'SC-DL12-D06H-A1-61RE-WH': 28,

    'FVFL1320VE1': 4,
    'FVFL1315NL1': 4,
    'FVFL1310VE1': 4,
    'FVFL0820VE1': 4,
    'FVFL0815NL1': 4,
    'FV-FL0810VE1': 4,

    'LLL-VB1': 100
  };

  var NOTICE_ID = 'ss-moq-notice';
  var STYLE_ID = 'ss-moq-styles';

  var CHECKOUT_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]',
    'a[href="/checkout"]'
  ].join(',');

  var processingCheckout = false;
  var validateTimer = null;

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function shopifyUrl(path) {
    var root = rootPath();
    return root + String(path).replace(/^\//, '');
  }

  function toInt(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[char];
    });
  }

  function normalizeQuantity(quantity, multiple) {
    var qty = toInt(quantity);
    var moq = toInt(multiple);

    if (qty <= 0 || moq <= 1) return qty;

    return Math.max(moq, Math.ceil(qty / moq) * moq);
  }

  function getProductHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function ruleForHandle(handle) {
    return RULES_BY_HANDLE[String(handle || '').toLowerCase()] || 0;
  }

  function ruleForSku(sku) {
    return RULES_BY_SKU[String(sku || '').trim().toUpperCase()] || 0;
  }

  function ruleForCartItem(item) {
    return ruleForSku(item && item.sku) || ruleForHandle(item && item.handle);
  }

  function formatItemName(item) {
    if (!item) return 'This item';
    return item.product_title || item.title || item.sku || item.handle || 'This item';
  }

  function getViolations(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.reduce(function (violations, item) {
      var moq = ruleForCartItem(item);
      if (!moq) return violations;

      var currentQty = toInt(item.quantity);
      var requiredQty = normalizeQuantity(currentQty, moq);

      if (currentQty > 0 && currentQty !== requiredQty) {
        violations.push({
          key: item.key,
          variant_id: item.variant_id,
          sku: item.sku,
          handle: item.handle,
          title: formatItemName(item),
          quantity: currentQty,
          moq: moq,
          required: requiredQty
        });
      }

      return violations;
    }, []);
  }

  function buildUpdatesFromViolations(violations) {
    var updates = {};

    violations.forEach(function (violation) {
      if (violation.key) {
        updates[violation.key] = violation.required;
      } else if (violation.variant_id) {
        updates[violation.variant_id] = violation.required;
      }
    });

    return updates;
  }

  async function fetchCart() {
    var response = await fetch(shopifyUrl('cart.js'), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to read cart for MOQ validation.');
    }

    return response.json();
  }

  async function updateCartToRequiredMultiples(violations) {
    var updates = buildUpdatesFromViolations(violations);

    if (!Object.keys(updates).length) return null;

    var response = await fetch(shopifyUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: updates
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update MOQ quantities.');
    }

    return response.json();
  }

  function buildNoticeHtml(violations, mode) {
    if (!violations || !violations.length) return '';

    var items = violations.slice(0, 6).map(function (violation) {
      return (
        '<li>' +
          '<strong>' + escapeHtml(violation.title) + '</strong>: ' +
          escapeHtml(String(violation.quantity)) +
          ' entered; this item must be ordered in multiples of ' +
          '<strong>' + escapeHtml(String(violation.moq)) + '</strong>. ' +
          'Required quantity: <strong>' + escapeHtml(String(violation.required)) + '</strong>.' +
        '</li>'
      );
    }).join('');

    var extra = violations.length > 6
      ? '<li>+' + escapeHtml(String(violations.length - 6)) + ' more MOQ line(s).</li>'
      : '';

    var lead = mode === 'fixed'
      ? 'MOQ quantities were adjusted. Please review your cart before checkout.'
      : 'Some items must be ordered in supplier case-pack multiples before checkout.';

    return (
      '<div id="' + NOTICE_ID + '" class="ss-moq-notice" role="alert" aria-live="assertive">' +
        '<div class="ss-moq-notice__title">Minimum order quantity check</div>' +
        '<p>' + lead + '</p>' +
        '<ul>' + items + extra + '</ul>' +
        '<button type="button" class="button button--secondary ss-moq-notice__fix" data-ss-moq-fix>' +
          'Round cart quantities' +
        '</button>' +
      '</div>'
    );
  }

  function findNoticeTarget() {
    return (
      document.querySelector('#main-cart-footer .cart__blocks') ||
      document.querySelector('.cart__footer .cart__blocks') ||
      document.querySelector('.drawer__footer .cart__ctas') ||
      document.querySelector('.cart-notification__links') ||
      document.querySelector('main') ||
      document.body
    );
  }

  function renderNotice(violations, mode) {
    var existing = document.getElementById(NOTICE_ID);
    if (existing) existing.remove();

    if (!violations || !violations.length) return;

    var target = findNoticeTarget();
    if (!target) return;

    target.insertAdjacentHTML('afterbegin', buildNoticeHtml(violations, mode));
  }

  function setCheckoutVisualState(blocked) {
    document.querySelectorAll(CHECKOUT_SELECTORS).forEach(function (el) {
      el.classList.toggle('ss-moq-checkout-blocked', !!blocked);
      el.setAttribute('aria-disabled', blocked ? 'true' : 'false');

      if (blocked) {
        el.setAttribute('data-ss-moq-blocked', 'true');
      } else {
        el.removeAttribute('data-ss-moq-blocked');
      }
    });

    document.querySelectorAll([
      '.cart__dynamic-checkout-buttons',
      '.dynamic-checkout__content',
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '.shopify-payment-button__more-options',
      'shopify-accelerated-checkout',
      'shopify-accelerated-checkout-cart'
    ].join(',')).forEach(function (el) {
      el.classList.toggle('ss-moq-hidden', !!blocked);
    });
  }

  function applyCartQuantityAttributes(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function (item) {
      var moq = ruleForCartItem(item);
      if (!moq) return;

      var selectors = [
        '[data-quantity-variant-id="' + item.variant_id + '"]',
        'input[name="updates[]"][id*="' + item.variant_id + '"]',
        'input.quantity__input[data-index]'
      ];

      document.querySelectorAll(selectors.join(',')).forEach(function (input) {
        var value = toInt(input.value);
        if (value !== toInt(item.quantity)) return;

        input.setAttribute('min', value === 0 ? '0' : String(moq));
        input.setAttribute('data-min', value === 0 ? '0' : String(moq));
        input.setAttribute('step', String(moq));
        input.setAttribute('data-ss-moq', String(moq));
      });
    });
  }

  async function validateCartUi() {
    try {
      var cart = await fetchCart();
      var violations = getViolations(cart);

      setCheckoutVisualState(violations.length > 0);
      renderNotice(violations);
      applyCartQuantityAttributes(cart);

      return violations;
    } catch (error) {
      console.warn('[SS MOQ]', error);
      return [];
    }
  }

  function debounceValidateCartUi() {
    clearTimeout(validateTimer);
    validateTimer = setTimeout(validateCartUi, 250);
  }

  function applyProductPageRules() {
    var handle = getProductHandleFromPath();
    var moq = ruleForHandle(handle);

    if (!moq) return;

    document.documentElement.classList.add('ss-moq-product');

    document.querySelectorAll([
      'form[action*="/cart/add"] input[name="quantity"]',
      'product-form input[name="quantity"]',
      '.product-form input[name="quantity"]'
    ].join(',')).forEach(function (input) {
      input.setAttribute('min', String(moq));
      input.setAttribute('data-min', String(moq));
      input.setAttribute('step', String(moq));
      input.setAttribute('data-ss-moq', String(moq));

      var current = toInt(input.value || input.getAttribute('value') || moq);
      var normalized = normalizeQuantity(current, moq);

      if (normalized !== current) {
        input.value = String(normalized);
      }
    });

    document.querySelectorAll([
      'shopify-accelerated-checkout',
      'shopify-accelerated-checkout-cart',
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '.shopify-payment-button__more-options',
      '.dynamic-checkout__content',
      '.product-form__buttons .shopify-payment-button'
    ].join(',')).forEach(function (el) {
      el.classList.add('ss-moq-hidden');
    });

    if (document.querySelector('.ss-moq-product-note')) return;

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('.product-form form');

    var buttons =
      document.querySelector('.product-form__buttons') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('button[name="add"]');

    var noteHtml =
      '<div class="ss-moq-product-note" role="note">' +
        'Supplier MOQ: order this item in multiples of <strong>' +
          escapeHtml(String(moq)) +
        '</strong>.' +
      '</div>';

    if (buttons && buttons.parentNode) {
      buttons.insertAdjacentHTML('beforebegin', noteHtml);
    } else if (form) {
      form.insertAdjacentHTML('beforeend', noteHtml);
    }
  }

  function normalizeAddFormQuantity(form) {
    var handle = getProductHandleFromPath();
    var moq = ruleForHandle(handle);

    if (!moq) return;

    var input = form.querySelector('input[name="quantity"]');
    if (!input) return;

    var current = toInt(input.value || input.getAttribute('value') || 1);
    var normalized = normalizeQuantity(current, moq);

    if (normalized !== current) {
      input.value = String(normalized);
    }
  }

  function getCheckoutHrefFromEvent(event) {
    var trigger = event && event.target && event.target.closest
      ? event.target.closest(CHECKOUT_SELECTORS)
      : null;

    if (trigger && trigger.tagName === 'A' && trigger.href) {
      return trigger.href;
    }

    return shopifyUrl('checkout');
  }

  async function validateThenProceedToCheckout(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    if (processingCheckout) return false;
    processingCheckout = true;

    var checkoutUrl = getCheckoutHrefFromEvent(event);

    try {
      var cart = await fetchCart();
      var violations = getViolations(cart);

      if (!violations.length) {
        window.location.href = checkoutUrl;
        return true;
      }

      setCheckoutVisualState(true);
      renderNotice(violations);

      await updateCartToRequiredMultiples(violations);

      renderNotice(violations, 'fixed');

      window.location.href = shopifyUrl('cart');
      return false;
    } catch (error) {
      console.warn('[SS MOQ]', error);
      processingCheckout = false;
      alert('We could not validate MOQ quantities. Please review your cart before checkout.');
      return false;
    }
  }

  async function roundCartQuantities(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      var cart = await fetchCart();
      var violations = getViolations(cart);

      if (!violations.length) {
        renderNotice([]);
        setCheckoutVisualState(false);
        return;
      }

      await updateCartToRequiredMultiples(violations);

      renderNotice(violations, 'fixed');
      setCheckoutVisualState(false);

      window.location.href = shopifyUrl('cart');
    } catch (error) {
      console.warn('[SS MOQ]', error);
      alert('We could not update MOQ quantities. Please refresh the cart and try again.');
    }
  }

  function bindEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';

      if (action.indexOf('/cart/add') !== -1 || form.closest('product-form')) {
        normalizeAddFormQuantity(form);
        return;
      }

      var submitter = event.submitter;
      var isCheckoutSubmit =
        submitter &&
        submitter.getAttribute &&
        submitter.getAttribute('name') === 'checkout';

      if (isCheckoutSubmit) {
        validateThenProceedToCheckout(event);
      }
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || !target.closest) return;

      var fixButton = target.closest('[data-ss-moq-fix]');
      if (fixButton) {
        roundCartQuantities(event);
        return;
      }

      var checkoutTrigger = target.closest(CHECKOUT_SELECTORS);
      if (checkoutTrigger) {
        validateThenProceedToCheckout(event);
      }
    }, true);

    document.addEventListener('change', function (event) {
      var input = event.target;

      if (!input || !input.matches || !input.matches('input[data-ss-moq]')) return;

      var moq = toInt(input.getAttribute('data-ss-moq'));
      var current = toInt(input.value);
      var normalized = normalizeQuantity(current, moq);

      if (normalized !== current) {
        input.value = String(normalized);
      }

      debounceValidateCartUi();
    }, true);

    document.addEventListener('cart:updated', debounceValidateCartUi);
    document.addEventListener('cart:update', debounceValidateCartUi);
    document.addEventListener('cart:change', debounceValidateCartUi);
  }

  function observeDynamicCartChanges() {
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      applyProductPageRules();
      debounceValidateCartUi();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = [
      '.ss-moq-hidden{display:none!important;}',
      '.ss-moq-product .shopify-payment-button{display:none!important;}',
      '.ss-moq-product .shopify-payment-button__button{display:none!important;}',
      '.ss-moq-product .shopify-payment-button__more-options{display:none!important;}',
      '.ss-moq-product shopify-accelerated-checkout{display:none!important;}',
      '.ss-moq-product shopify-accelerated-checkout-cart{display:none!important;}',
      '.ss-moq-product .dynamic-checkout__content{display:none!important;}',
      '.ss-moq-checkout-blocked{opacity:.65;cursor:not-allowed;}',
      '.ss-moq-notice{margin:0 0 1rem;padding:.85rem 1rem;border:1px solid rgba(185,28,28,.35);border-left:4px solid #b91c1c;border-radius:.75rem;background:rgba(185,28,28,.06);line-height:1.35;}',
      '.ss-moq-notice__title{font-weight:700;margin:0 0 .35rem;color:#7f1d1d;}',
      '.ss-moq-notice p{margin:.25rem 0 .5rem;}',
      '.ss-moq-notice ul{margin:.25rem 0 .75rem 1.2rem;padding:0;}',
      '.ss-moq-notice li{margin:.2rem 0;}',
      '.ss-moq-product-note{display:block;width:100%;flex:0 0 100%;clear:both;box-sizing:border-box;margin:.75rem 0 1rem;padding:.65rem .85rem;border-radius:.5rem;background:rgba(0,0,0,.04);font-size:.92em;line-height:1.35;color:rgba(0,0,0,.78);}',
      '.ss-moq-notice__fix{margin-top:.25rem;}'
    ].join('');

    document.head.appendChild(style);
  }

  function init() {
    injectStyles();
    bindEvents();
    applyProductPageRules();
    validateCartUi();
    observeDynamicCartChanges();

    setTimeout(function () {
      applyProductPageRules();
      validateCartUi();
    }, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();